declare namespace $ {

	type $mol_list__rows_bog_vmap_app_menu_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['items'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__event_bog_vmap_app_menu_2 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_menu['hold'] > ): ReturnType< $bog_vmap_app_menu['hold'] >,
			wheel( next?: ReturnType< $bog_vmap_app_menu['hold'] > ): ReturnType< $bog_vmap_app_menu['hold'] >,
			contextmenu( next?: ReturnType< $bog_vmap_app_menu['hold'] > ): ReturnType< $bog_vmap_app_menu['hold'] >,
		})  & ReturnType< $mol_list['event'] >
		,
		ReturnType< $mol_list['event'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__keys_bog_vmap_app_menu_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['copy_keys'] >
		,
		ReturnType< $bog_vmap_app_menu_item['keys'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['copy'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_7 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__keys_bog_vmap_app_menu_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['remove_keys'] >
		,
		ReturnType< $bog_vmap_app_menu_item['keys'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['remove'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__keys_bog_vmap_app_menu_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['group_keys'] >
		,
		ReturnType< $bog_vmap_app_menu_item['keys'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['group'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_15 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__keys_bog_vmap_app_menu_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['ungroup_keys'] >
		,
		ReturnType< $bog_vmap_app_menu_item['keys'] >
	>
	type $bog_vmap_app_menu_item__enabled_bog_vmap_app_menu_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['ungroup_enabled'] >
		,
		ReturnType< $bog_vmap_app_menu_item['enabled'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['ungroup'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_20 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__hint_bog_vmap_app_menu_21 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['hint'] >
	>
	type $bog_vmap_app_menu_item__enabled_bog_vmap_app_menu_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['reset_enabled'] >
		,
		ReturnType< $bog_vmap_app_menu_item['enabled'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_23 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['reset'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_25 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__keys_bog_vmap_app_menu_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['wrap_keys'] >
		,
		ReturnType< $bog_vmap_app_menu_item['keys'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_27 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['wrap'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_28 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_29 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__enabled_bog_vmap_app_menu_30 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['parent_enabled'] >
		,
		ReturnType< $bog_vmap_app_menu_item['enabled'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_31 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['parent'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_32 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_33 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_34 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['enter'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_35 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_36 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_37 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['board'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_38 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	type $bog_vmap_app_menu_item__title_bog_vmap_app_menu_39 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_menu_item['title'] >
	>
	type $bog_vmap_app_menu_item__keys_bog_vmap_app_menu_40 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['fit_keys'] >
		,
		ReturnType< $bog_vmap_app_menu_item['keys'] >
	>
	type $bog_vmap_app_menu_item__act_bog_vmap_app_menu_41 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['fit'] >
		,
		ReturnType< $bog_vmap_app_menu_item['act'] >
	>
	type $bog_vmap_app_menu_item__done_bog_vmap_app_menu_42 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_menu['close'] >
		,
		ReturnType< $bog_vmap_app_menu_item['done'] >
	>
	export class $bog_vmap_app_menu extends $mol_pop {
		items( ): readonly($mol_view)[]
		List( ): $mol_list
		copy_keys( ): string
		remove_keys( ): string
		group_keys( ): string
		ungroup_keys( ): string
		wrap_keys( ): string
		fit_keys( ): string
		showed( next?: boolean ): boolean
		left( ): string
		top( ): string
		on_node( ): boolean
		editable( ): boolean
		apple( ): boolean
		copy( next?: any ): any
		remove( next?: any ): any
		wrap( next?: any ): any
		group( next?: any ): any
		ungroup( next?: any ): any
		ungroup_enabled( ): boolean
		reset( next?: any ): any
		reset_enabled( ): boolean
		parent( next?: any ): any
		parent_enabled( ): boolean
		enter( next?: any ): any
		board( next?: any ): any
		fit( next?: any ): any
		close( next?: any ): any
		hold( next?: any ): any
		style( ): ({ 
			'left': ReturnType< $bog_vmap_app_menu['left'] >,
			'top': ReturnType< $bog_vmap_app_menu['top'] >,
		})  & ReturnType< $mol_pop['style'] >
		Anchor( ): $mol_view
		bubble_content( ): readonly(any)[]
		Copy( ): $bog_vmap_app_menu_item
		Remove( ): $bog_vmap_app_menu_item
		Group( ): $bog_vmap_app_menu_item
		Ungroup( ): $bog_vmap_app_menu_item
		Reset( ): $bog_vmap_app_menu_item
		Wrap( ): $bog_vmap_app_menu_item
		Parent( ): $bog_vmap_app_menu_item
		Enter( ): $bog_vmap_app_menu_item
		Board( ): $bog_vmap_app_menu_item
		Fit( ): $bog_vmap_app_menu_item
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map